import React, {Component} from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import axios from 'axios';

class CveDetailPage extends Component {

    url = "https://cve-dashboard-service.herokuapp.com/api/cves/";

    constructor (props) {
        super(props);
        this.state = {
            cve: [],
            products: [],
            isLoading: true    
        }
    }

    /**
     * Calls the rest service
     */
    fetchData() {
        axios.get(this.url + this.props.cveId).then ((response) => {
            this.setState({
                cve: response.data,
                products: response.data.products,
                isLoading: false
            })
        });
    }

    /**
     * load the detail
     */
    componentDidMount() {
        this.fetchData();
    }

    /**
     * Reload the detail if user clicks on a different id
     * @param {} prevProps 
     */
    componentDidUpdate(prevProps) {
        if(prevProps.cveId !== this.props.cveId) {
            this.setState({
                isLoading: true
            })
            this.fetchData();
        }
    }

    render () {

        return (
            <div>
                <Header />

                <section id="report-section">
                <div className="container">
                    <div className="report-title">
                        <p className="h3">CVE Detail</p>
                    </div>                
                    <div>
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Key</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>ID</td>
                                    <td>{this.state.cve.id}</td>
                                </tr>                      
                                <tr>
                                    <td>Date</td>
                                    <td>{this.state.cve.formattedDate}</td>
                                </tr>                                                        
                                <tr>
                                    <td>Severity</td>
                                    <td>{this.state.cve.severity}</td>
                                </tr>
                                <tr>
                                    <td>Description</td>
                                    <td>{this.state.cve.description}</td>
                                </tr>                                           
                                <tr>
                                    <td>Category</td>
                                    <td>{this.state.cve.category}</td>
                                </tr>
                                <tr>
                                    <td>Products(s)</td>
                                    <td>
                                       {this.state.products.map((product, key) => {
                                           return (
                                                <p key={key}>{product}</p>
                                           )
                                       })}                                
                                    </td>
                                </tr>                                                               
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        )
    }
} 


export default CveDetailPage;